module.exports = __webpack_public_path__ + "3816599407829da68e461d204342e6d0.svg";